import { BookSyncPreference } from '@blk/awt-userpreference';
import { isUndefined, omitBy } from 'lodash';
import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { transformTimestamps } from '../../utils/ApiUtils';
import { isAGraphEnabled } from './AGraphUtils';
import { userPreferenceApi } from './Base';

const path = '/v1/booksync-preferences';

export async function getAllBookSyncPreference(pkg: string, loginOverride?: string, signal?: AbortSignal) {
  const response = await userPreferenceApi.get<AGraphWrappedType<BookSyncPreference[], 'bookSyncPreferences'>>(path, {
    params: omitBy({ tenant: pkg, loginOverride }, isUndefined),
    signal,
  });
  return unwrapAGraphResponse(response, 'bookSyncPreferences');
}
export function getBookSyncPreference(platformId: string, pkg: string, signal?: AbortSignal) {
  return userPreferenceApi.get<BookSyncPreference>(`${path}/${platformId}`, { params: { tenant: pkg }, signal });
}
export function postBookSyncPreference(userPreference: BookSyncPreference, pkg: string, signal?: AbortSignal) {
  const payload = isAGraphEnabled()
    ? transformTimestamps(userPreference, ['createdAt', 'updatedAt'], 'stringify', {
        recursiveFieldPatterns: ['userPreferenceMetadata'],
      })
    : userPreference;
  return userPreferenceApi.post<BookSyncPreference, null>(path, payload, {
    params: { tenant: pkg },
    signal,
  });
}
export function deleteBookSyncPreference(platformId: string, pkg: string, signal?: AbortSignal) {
  return userPreferenceApi.delete<null>(`${path}/${platformId}`, { params: { tenant: pkg }, signal });
}
